import script from "./lefthtPie.vue?vue&type=script&setup=true&lang=js"
export * from "./lefthtPie.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__